function toggleFilter() {
    let x = document.querySelector(".sq-filter-main");
    x.classList.toggle("opening");
}
function toggleClass() {
    let y = document.querySelector(".sq-filter-main");
    y.classList.remove("opening");
}
function removeClass() {
    let z = document.querySelector(".sq-filter-main");
    z.classList.remove("opening");
}

window.sq = window.sq || {};


window.addEventListener("load", () => {
    if (window.matchMedia("(max-width: 767px)").matches) {
        document
            .getElementById("Search-In-Modal")
            .addEventListener("focusin", () => {
                document.querySelector(".sq-dropdown-body").style.maxHeight = "100%";
            });
        document
            .getElementById("Search-In-Modal")
            .addEventListener("focusout", () => {
                document.querySelector(".sq-dropdown-body").style.maxHeight = "0px";
            });
    }
});

window.sq.initSearch = (store) => {
    store.search();
};

window.onload = function() {
    // Loop through all elements with class 'sq-sort-label'
    document.querySelectorAll('span.sq-sort-label').forEach(function(element) {
        element.innerHTML = 'sort by';
    });
};



setTimeout(()=>{
  // console.log("hehhh")
    if(document.querySelector(".sq-filter-main")) document.querySelector(".sq-filter-main").style.visibility = null;
    if(document.querySelector(".sparq-container")) document.querySelector(".sparq-container").style.visibility = null;

}, 200);

setTimeout(() => {
  const btnWrapper = document.querySelector(".row.btn-wrapper");
  if (btnWrapper) btnWrapper.style.display = "block";

  const sqHeads = document.querySelectorAll(".sq-head");
  for (let i = 0; i < sqHeads.length; i++) {
    sqHeads[i].style.display = "block";
  }
}, 500);


window.addEventListener("keydown",(e)=>{
    if (e.key === "Escape") {
        document.querySelector("footer").click();
    }
});

(function () {
  function hideIfNoResults(container) {
    const noResults = container.querySelector('.sq-no-results');
    const isVisible = noResults && noResults.offsetParent !== null;
    container.style.display = isVisible ? 'none' : '';

    // Call adjustFlexWidths after adjusting visibility
    adjustFlexWidths();
  }

  // Set up observer for any container when it becomes available
  function watchContainer(selector) {
    const wait = setInterval(() => {
      const target = document.querySelector(selector);
      if (target) {
        clearInterval(wait);

        // Initial check
        hideIfNoResults(target);

        // Set up mutation observer on the container
        const observer = new MutationObserver(() => hideIfNoResults(target));
        observer.observe(target, {
          childList: true,
          subtree: true
        });
      }
    }, 200);
  }

  // Start watching each section individually
  document.addEventListener('DOMContentLoaded', () => {
    watchContainer('.sq-app1-dropdown'); // Products
    watchContainer('.sq-app2-dropdown .sq-app.dropdown-list:nth-of-type(1)'); // Collections
    watchContainer('.sq-app2-dropdown .sq-app.dropdown-list:nth-of-type(2)'); // Pages
  });

  function adjustFlexWidths() {
  const app1 = document.querySelector('.sq-app1-dropdown');
  const app2 = document.querySelector('.sq-app2-dropdown');
  const flexWrapper = document.querySelector('.sparq-dropdown-flex');
  const globalMessage = document.querySelector('.sq-no-global-results');

  const app1Visible = app1 && app1.style.display !== 'none';
  const visibleApp2Lists = app2 ? app2.querySelectorAll('.sq-app.dropdown-list:not([style*="display: none"])') : [];
  const app2Visible = visibleApp2Lists.length > 0;

  // Reset widths
  app1?.classList.remove('is-full-width');
  app2?.classList.remove('is-full-width');

  // Handle flex layout width
  if (app1Visible && !app2Visible) {
    app1?.classList.add('is-full-width');
  }

  if (!app1Visible && app2Visible) {
    app2?.classList.add('is-full-width');
  }

  // Adjust flex direction
  if (flexWrapper) {
    if (!app1Visible) {
      flexWrapper.classList.add('flex-row');
    } else {
      flexWrapper.classList.remove('flex-row');
    }
  }

  // Show global "no result" message if nothing is visible
  if (globalMessage) {
    if (!app1Visible && !app2Visible) {
      globalMessage.style.display = 'block';
      flexWrapper.style.display='none';
    } else {
      globalMessage.style.display = 'none';
      flexWrapper.style.display='flex';
    }
  }
}

})();









